/* ========= Mobile carousel logic ========= */
(function () {
  const carousels = document.querySelectorAll('.fashion-carousel');

  carousels.forEach(c => {
    const slides = c.querySelectorAll('img');
    const dots   = c.querySelectorAll('.slide-dot');
    let i = 0;

    /* Activate slide idx */
    const show = idx => {
      slides.forEach((s, j) => s.classList.toggle('active', j === idx));
      dots  .forEach((d, j) => {
        d.classList.toggle('active-dot',   j === idx);
        d.classList.toggle('inactive-dot', j !== idx);
      });
      i = idx;
    };

    c.show = show;                     // ✦ ① חושף את show כ-method על הקרוסלה

    /* חץ קדימה */
    c.querySelector('.next').addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      show((i + 1) % slides.length);
    });

    /* חץ אחורה */
    c.querySelector('.prev').addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      show((i ? i : slides.length) - 1);
    });

    /* נקודות */
    dots.forEach(d => d.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      show(+d.dataset.index);
    }));

    /* סווייפ במובייל – נעילת כיוון */
    const THRESH = 24;   // כמה פיקסלים לפני שמחשיבים סווייפ
    const RATIO  = 1.2;  // אופקי חייב לגבור ב-20% על האנכי

    let startX = 0, startY = 0;
    let tracking = false, swiping = false, scrolling = false;

    function onTouchStart(e){
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      tracking = true;
      swiping = false;
      scrolling = false;
    }

    function onTouchMove(e){
      if (!tracking) return;
      const t  = e.touches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      // החלטה חד-פעמית על כיוון כאשר עברנו את הסף
      if (!swiping && !scrolling && (Math.abs(dx) > THRESH || Math.abs(dy) > THRESH)){
        if (Math.abs(dx) > Math.abs(dy) * RATIO){
          swiping = true;         // ננעלנו על סווייפ אופקי
          e.preventDefault();     // עוצר גלילה אנכית (נדרש passive:false למטה)
        } else {
          scrolling = true;       // זו גלילה אנכית → לא להחליף שקופית
          return;
        }
      }

      if (swiping){
        e.preventDefault();       // מחזיק את המסך בזמן גרירה אופקית
        // (אין כאן drag/translate בפועל – רק נעילת גלילה)
      }
    }

    function onTouchEnd(e){
      if (!tracking) return;
      tracking = false;

      const t  = e.changedTouches[0];
      const dx = t.clientX - startX;

      if (swiping && Math.abs(dx) > THRESH){
        // NEXT / PREV לפי הכיוון
        show(dx < 0 ? (i + 1) % slides.length
                    : (i ? i : slides.length) - 1);
      }
      swiping = false;
      scrolling = false;
    }

    // חשוב: passive:false על touchmove כדי ש-preventDefault יעבוד
    c.addEventListener('touchstart', onTouchStart, { passive: true  });
    c.addEventListener('touchmove',  onTouchMove,  { passive: false });
    c.addEventListener('touchend',   onTouchEnd,   { passive: true  });

  });
})();


/* ========= Change main slide when variant (color) changes ========= */
document.addEventListener('DOMContentLoaded', () => {
  /* ‎① קורא את כל הווריאנטים כ-JSON – Shopify מייצרת אלמנט ProductJson‎ */
  const productJsonEl = document.querySelector('[id^="ProductJson-"]');
  if (!productJsonEl) return;                                    // בטיחות
  const variants = JSON.parse(productJsonEl.textContent).variants;

  /* ‎② מחזיר variant לפי הבחירות הנוכחיות */
  function currentVariant () {
    const selections = [];
    document.querySelectorAll('.option-group input:checked')
            .forEach(inp => selections.push(inp.value));
    return variants.find(v => v.options.every((opt, idx) => opt === selections[idx]));
  }

  /* ‎③ מחליף סלייד אם ל-variant יש featured_media */
  function updateCarousel () {
    const v = currentVariant();
    if (!v || !v.featured_media) return;

    const mediaId  = String(v.featured_media.id);
    const carousel = document.querySelector('.fashion-carousel');
    if (!carousel || !carousel.show) return;

    const imgs = carousel.querySelectorAll('img[data-media-id]');
    imgs.forEach((img, idx) => {
      if (img.dataset.mediaId === mediaId) carousel.show(idx);
    });
  }

  /* ‎④ מאזין לכל שינוי ברדיו */
  document.querySelectorAll('.option-group input[type="radio"]')
          .forEach(r => r.addEventListener('change', updateCarousel));
});

/* === Size Guide modal – open/close === */
(function () {
  function openSG() {
    const m = document.getElementById('size-guide-modal');
    if (!m) return;
    m.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }
  function closeSG() {
    const m = document.getElementById('size-guide-modal');
    if (!m) return;
    m.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('.size-guide-link');
    if (openBtn) { e.preventDefault(); openSG(); return; }

    if (
      e.target.id === 'size-guide-modal' ||     // קליק על האוברליי
      e.target.closest('.sg-close')             // קליק על כפתור ×
    ) { closeSG(); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSG();
  });
})();

document.addEventListener('click', (e) => {
  if (e.target.closest('#size-guide-modal .size-btn')) {
    const m = document.getElementById('size-guide-modal');
    const cmBtn = m.querySelector('.cm-btn');
    const inBtn = m.querySelector('.in-btn');
    const cmWrap = m.querySelector('.cm-wrap');
    const inWrap = m.querySelector('.in-wrap');
    if (e.target.closest('.cm-btn')) {
      cmBtn?.classList.add('active'); inBtn?.classList.remove('active');
      if (cmWrap) cmWrap.style.display = 'block';
      if (inWrap) inWrap.style.display = 'none';
    } else {
      inBtn?.classList.add('active'); cmBtn?.classList.remove('active');
      if (inWrap) inWrap.style.display = 'block';
      if (cmWrap) cmWrap.style.display = 'none';
    }
  }
});

/* === Related carousel arrows === */
(function(){
  const wraps = document.querySelectorAll('.related-wrap');
  wraps.forEach(wrap => {
    const row  = wrap.querySelector('.recs-row');
    const prev = wrap.querySelector('.recs-prev');
    const next = wrap.querySelector('.recs-next');
    if (!row || !prev || !next) return;

    const page = () => row.clientWidth; // כמה לגלול בכל קליק
    const update = () => {
      const max = row.scrollWidth - row.clientWidth - 1;
      prev.disabled = row.scrollLeft <= 0;
      next.disabled = row.scrollLeft >= max;
    };

    prev.addEventListener('click', () => row.scrollBy({left: -page(), behavior:'smooth'}));
    next.addEventListener('click', () => row.scrollBy({left:  page(), behavior:'smooth'}));
    row.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
  });
})();